import React from 'react';
import { NavLink, Outlet, useLocation } from 'react-router-dom';
import { Send, Megaphone, Zap, Layout, Cog, Layers, Activity, MessageSquare, ScrollText, Stethoscope } from 'lucide-react';
import PageHeader from '../../components/PageHeader';

const tabs = [
  { name: 'Live Chat', to: '/dashboard/meta/chat', icon: MessageSquare },
  { name: 'Direct Signal', to: '/dashboard/meta/direct', icon: Send },
  { name: 'Bulk Dispatch', to: '/dashboard/meta/campaigns', icon: Megaphone },
  { name: 'Automation Hub', to: '/dashboard/meta/automation', icon: Zap },
  { name: 'Cloud Templates', to: '/dashboard/meta/templates', icon: Layout },
  { name: 'WA Flows', to: '/dashboard/whatsapp-flows', icon: Layers, startsWith: '/dashboard/whatsapp-flows/builder' },
  { name: 'Flow Sessions', to: '/dashboard/whatsapp-flows/sessions', icon: Activity },
  { name: 'Logs', to: '/dashboard/meta/logs', icon: ScrollText },
  { name: 'Diagnostics', to: '/dashboard/meta/diagnostics', icon: Stethoscope },
  { name: 'API Configuration', to: '/dashboard/meta/settings', icon: Cog },
];

export default function MetaDashboardLayout() {
  const location = useLocation();

  return (
    <div className="flex flex-col h-full">
      <div className="px-4 md:px-6 pt-4 md:pt-6 bg-white border-b border-[#D8DDE6]">
        <div className="mb-4">
          <PageHeader
            title="Meta WhatsApp Workspace"
            subtitle="Manage your official WhatsApp communications, templates, and automation."
            icon={Send}
          />
        </div>
        <nav className="flex space-x-1 overflow-x-auto" aria-label="Tabs">
          {tabs.map((tab) => {
            const Icon = tab.icon;
            const isActive = location.pathname === tab.to || (tab.startsWith && location.pathname.startsWith(tab.startsWith));
            return (
              <NavLink
                key={tab.name}
                to={tab.to}
                className={`flex shrink-0 items-center gap-2 py-3 px-4 text-sm font-medium border-b-2 whitespace-nowrap transition-colors ${
                  isActive
                    ? 'border-[#0176D3] text-[#0176D3]'
                    : 'border-transparent text-[#706E6B] hover:text-[#080707] hover:border-[#D8DDE6]'
                }`}
              >
                <Icon size={16} />
                {tab.name}
              </NavLink>
            );
          })}
        </nav>
      </div>

      <div className="flex-1 overflow-auto p-4 md:p-6 bg-[#F3F3F3]">
        <Outlet />
      </div>
    </div>
  );
}
